import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZoneChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AutoFocusDirective } from '@app/@core/directives/auto-focus.directive';
import { BlockcutcopypasteDirective } from '@app/@core/directives/blockcutcopypaste.directive';
import { AuthService } from '@app/@core/services/auth.service';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { HelpDeskModule } from '@app/pages/help-desk/help-desk.module';
import { PagesComponent } from '@app/pages/pages.component';
import { ChatbotRasaModule } from '@app/shared/features/chatbot/lib/chatbot-rasa.module';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { SharedModule } from '@app/shared/shared.module';
import { CoreModule } from '@core/core.module';
import { DirectivesModule } from '@core/directives/directives.module';
import { HttpService } from '@core/services/http.service';
import { CardyHelpDeskModule } from '@pics-module/help-desk';
import { DataStoreService } from './@core/services/data-store.service';
import { SolutionWrapperModule } from './shared/features/custom-solution/solution-wrapper-module';
import { RegistrationModule } from './registration/registration.module';
import { ApplicationTypeDialogComponent } from './application-type-dialog/application-type-dialog.component';
import { AppLoginModule } from './app-login/app-login.module';
import { FingerprintRegistrationComponent } from './registration/fingerprint-registration/fingerprint-registration.component';
import { LEARegistrationComponent } from './registration/lea-registration/lea-registration.component';
import { ManageProfileModule } from './pages/manage-profile/manage-profile.module';
import { ApplicationDashboardModule } from './application-dashboard/application-dashboard.module';
import { MyApplicationsModule } from './my-application/my-application.module';
import { TimelineComponent } from './timeline/timeline.component';
import { DxDataGridModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { ToggleMaskDirective } from './shared/directives/toggle-mask.directive';
import { ComplaintFormModule } from './app-login/complaint-form/complaint-form.module';
import { TimeLineModule } from './timeline/timeline.module';
import { PaymentModule } from './payment/Payment.module';
import { DecisionRolePageModule } from './decision-role-page/decision-role-page.module';
import { CommonUtilsModule } from '@pics-core/common-utils';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { PaymentReconciliationReportComponent } from './payment-reconciliation-report/payment-reconciliation-report.component';
import { DynamicSearchFormComponent } from '@app/dynamic-search-form/dynamic-search-form.component';
import { BackgroundReportsComponent } from './Dashboard-Reports/background-reports/background-reports.component';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { AnnouncementSharedModule } from '@pics-core/dynamic';
import { loadMessages } from 'devextreme/localization';

loadMessages({
  en: {
    'dxDataGrid-ariaDataGrid': ''
  }
});

@NgModule({
  declarations: [AppComponent, PagesComponent, AutoFocusDirective, BlockcutcopypasteDirective,
    ApplicationTypeDialogComponent,  FingerprintRegistrationComponent,
    LEARegistrationComponent,
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    CoreModule,
    DirectivesModule,
    ChatbotRasaModule,
    HelpDeskModule,
    CardyHelpDeskModule,
    SolutionWrapperModule,
    RegistrationModule,
    MyApplicationsModule,
    AppLoginModule,
    ManageProfileModule,
    ApplicationDashboardModule,
    DxDataGridModule,
    CommonModule,
    ToggleMaskDirective,
    ComplaintFormModule,
    TimeLineModule,
    PaymentModule,
    PowerBIEmbedModule,
    DynamicSearchFormComponent,
    DataGridComponent,
    CommonUtilsModule.forRoot({
      httpService : HttpService
    }),
    DecisionRolePageModule,
    PaymentReconciliationReportComponent,
    BackgroundReportsComponent,
    AnnouncementSharedModule
  ],
  providers: [provideZoneChangeDetection(), HttpService, AuthService,DataStoreService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
